import { lazy, Suspense } from "react";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import HeroSection from "@/components/HeroSection";
import ClientsMarquee from "@/components/ClientsMarquee";

const VideoSection = lazy(() => import("@/components/VideoSection"));
const FeaturesShowcase = lazy(() => import("@/components/FeaturesShowcase"));
const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const AutomationSection = lazy(() => import("@/components/AutomationSection"));
const MobileSection = lazy(() => import("@/components/MobileSection"));
const TenantPortalSection = lazy(() => import("@/components/TenantPortalSection"));
const ComparisonSection = lazy(() => import("@/components/ComparisonSection"));
const CompetitorTable = lazy(() => import("@/components/CompetitorTable"));
const AdvantageSection = lazy(() => import("@/components/AdvantageSection"));
const SupportSection = lazy(() => import("@/components/SupportSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const DemoCTASection = lazy(() => import("@/components/DemoCTASection"));

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "OneStep",
  url: "https://onestep.co.il",
  logo: "https://onestep.co.il/assets/logo.webp",
  description: "OneStep, מערכת מקצועית לניהול וקידום פרויקטי פינוי בינוי והתחדשות עירונית בישראל",
  foundingDate: "2020",
  founder: {
    "@type": "Person",
    name: "אפרים ספנייב",
    jobTitle: "בעלים",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "info@onestep.co.il",
    telephone: "+972-50-420-9000",
    contactType: "customer service",
    availableLanguage: ["Hebrew", "English", "Arabic", "Russian"],
  },
  sameAs: [],
};

const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "OneStep",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  description: "מערכת לפינוי בינוי, ניהול דיירים, חתימות דיגיטליות, פורטל דיירים רב-שפתי, CRM, דוחות ואוטומציות לקידום פרויקטי התחדשות עירונית",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "ILS",
    description: "תקופת ניסיון חינם",
  },
  featureList: "ניהול דיירים, חתימות דיגיטליות, פורטל דיירים, SMS ממותג, AI חכם, מכרזים דיגיטליים, כרטיסי ביקור",
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "OneStep",
  url: "https://onestep.co.il",
  inLanguage: "he",
  description: "מערכת מקצועית לפינוי בינוי והתחדשות עירונית, OneStep",
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "OneStep",
  url: "https://onestep.co.il",
  logo: "https://onestep.co.il/assets/logo.webp",
  telephone: "+972-50-420-9000",
  email: "info@onestep.co.il",
  description: "מערכת SaaS מובילה לניהול פרויקטי פינוי בינוי והתחדשות עירונית בישראל",
  areaServed: {
    "@type": "Country",
    name: "Israel",
  },
  serviceType: "ניהול פרויקטי התחדשות עירונית",
  priceRange: "₪₪",
  knowsLanguage: ["he", "ar", "ru"],
};

const Index = () => {
  return (
    <Layout>
      <SEO
        title="מערכת לפינוי בינוי והתחדשות עירונית"
        description="מערכת OneStep לניהול פינוי בינוי והתחדשות עירונית: ניהול דיירים, חתימות דיגיטליות, פורטל דיירים, CRM ואוטומציות. ניסיון מ-200 פרויקטים בישראל."
        path="/"
        jsonLd={[organizationSchema, softwareSchema, websiteSchema, localBusinessSchema]}
        breadcrumbs={[{ name: "דף הבית", path: "/" }]}
      />

      <HeroSection />
      <ClientsMarquee />
      <Suspense fallback={null}>
        <VideoSection />
        <FeaturesShowcase />
        <FeaturesSection />
        <AutomationSection />
        <MobileSection />
        <TenantPortalSection />
        <ComparisonSection />
        <CompetitorTable />
        <SupportSection />
        <AdvantageSection />
        <FAQSection />
        <DemoCTASection />
      </Suspense>
    </Layout>
  );
};

export default Index;
